import { useBasket } from 'lib/hooks/basket/use-basket';

export const ValidDiscount = () => {
  const [basket, modifyBasket] = useBasket();

  return (
    <>
      <dl className='border border-gray-200 rounded-md overflow-hidden w-full relative mt-2'>
        <button
          className=' group absolute top-1 mt-px right-2 bg-yellow-dark rounded-full hover:bg-white'
          onClick={() => modifyBasket({ type: 'remove-discount' })}>
          <span className='sr-only'>remove discount</span>
          <svg
            className='w-8 h-4 text-white group-hover:text-yellow-dark'
            xmlns='http://www.w3.org/2000/svg'
            viewBox='0 0 20 20'
            fill='currentColor'>
            <path
              fillRule='evenodd'
              d='M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z'
              clipRule='evenodd'
            />
          </svg>
        </button>
        <h3 className='bg-yellow-dark text-white text-sm px-3 py-1'>
          {basket.discount.code}
        </h3>
        <dl className='grid grid-cols-2 divide-y text-sm'>
          <dt className='row-start-1 px-2 py-1 text-gray-700'>
            Discount Percentage:
            <span className='text-xstext-gray-600 block'>
              {basket.discount.applies_to.length > 0 &&
                'Restricted to specific books'}
            </span>
          </dt>
          <dd className='row-start-1 px-2 py-1 text-right text-gray-700'>
            {basket.discount.discount_value} %
          </dd>
        </dl>
      </dl>
    </>
  );
};
